// Real Estate Agent Assist videos on YouTube (@reassistapp). IDs come from
// the Android repo: store/social/video/YOUTUBE.md.

export const promoVideo = {
  id: "i1hnCUweeEM",
  title: "Real Estate Agent Assist: Every Deal in One Place",
};

// In the order a new user needs them.
export const howToVideos = [
  {
    slug: "add-listing",
    id: "st6SR42b3wM",
    title: "How to add your first listing",
    description:
      "Add a listing in under a minute (address, details and list price) and get its checklist, key dates and projected take-home.",
  },
  {
    slug: "contract-deadlines",
    id: "NC2RlEOwCLk",
    title: "How to track contract deadlines",
    description:
      "Set the contract date and fill in every deadline in one tap, listed in the order they come due.",
  },
  {
    slug: "split-and-cap",
    id: "GsLuUcRjZ_E",
    title: "How to set your brokerage split and cap",
    description:
      "Enter your split, annual cap and transaction fee so Financials shows what you really keep.",
  },
  {
    slug: "import-from-mls",
    id: "DjcqVQ6OpFg",
    title: "How to import listings from your MLS",
    description:
      "Pick your MLS export file and choose the listings to bring in; each one gets its own checklist.",
  },
  {
    slug: "import-with-template",
    id: "WJ8HT-KY9Tw",
    title: "How to import listings with the template",
    description:
      "No MLS export? Save the blank template, fill it in with Excel or Google Sheets, and import it.",
  },
  {
    slug: "automatic-backups",
    id: "RvhVFuctYes",
    title: "How to turn on automatic backups",
    description:
      "Turn on automatic backup and pick a folder for a fresh copy every day, kept off your phone.",
  },
];

export const HOW_TO_PATH = "/apps/real-estate-assist/how-to";
